/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable func-names */
/* eslint-disable no-undef */
import { removeUserback } from '@/features/feedback-tool/plugins/userback';

const ChatwootWebsiteToken = 'F4AQ1qg6Kccg2kCWjszTfB63';

export function removeLiveChat() {
  if (window.$chatwoot) {
    window.$chatwoot.reset();
    window.$chatwoot.toggleBubbleVisibility('hide');
  }
}

export function setLiveChat(userInfo) {
  removeUserback();
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility('show');
  }

  const isSmallScreen = window.innerWidth < 640;
  const bubbleType = isSmallScreen ? 'standard' : 'expanded_bubble';

  window.chatwootSettings = {
    position: 'right',
    type: bubbleType,
    launcherTitle: 'Chat with us',
  };
  ((function (d, t) {
    const BASE_URL = 'https://app.chatwoot.com';
    const g = d.createElement(t);
    const s = d.getElementsByTagName(t)[0];
    g.src = 'https://app.chatwoot.com/packs/js/sdk.js';
    g.defer = true;
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: ChatwootWebsiteToken,
        baseUrl: BASE_URL,
      });
    };
  })(document, 'script'));

  const setAttributes = () => {
    window.$chatwoot.setUser(userInfo.username, {
      name: `${userInfo.firstname} ${userInfo.lastname}`,
      email: userInfo.username,
      identifier_hash: userInfo.chatId,
    });
    window.$chatwoot.setCustomAttributes({
      account_number: userInfo.account,
    });
  };

  window.addEventListener('chatwoot:ready', setAttributes);
}
